import { isNull } from 'utils/tsHelpers';
import { removeScript } from 'utils/script';
import { LinkTarget } from '../types';
import { useSelectedHyperlink } from '../../hooks/useSelectedHyperlink';

export const useUpdateExistingHyperlink = () => {
  const selectedHyperlink = useSelectedHyperlink();
  return (displayText: string, href: string, target: LinkTarget) => {
    if (!isNull(selectedHyperlink)) {
      Object.assign(selectedHyperlink, { textContent: removeScript(displayText) });
      selectedHyperlink.setAttribute('href', removeScript(href));
      selectedHyperlink.setAttribute('target', target);
    }
  };
};
